import script from "./OHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./OHeader.vue?vue&type=script&lang=ts&setup=true"

import "./OHeader.vue?vue&type=style&index=0&id=0645e764&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0645e764"]])

export default __exports__